export const ROUTE_PATH = '/bonus-transfer';
